import { isWiseQuote } from './quoteFilters';

function sortWiseFollowedByOthers(q1, q2) {
  if (isWiseQuote(q1)) {
    return -1;
  }
  if (isWiseQuote(q2)) {
    return 1;
  }
  return q1.alias.localeCompare(q2.alias);
}

function sortQuotesByReceivedAmount(quotes, excludePartners = false) {
  const filteredQuotes = excludePartners ? quotes.filter((q) => q.partner === false) : quotes;
  return filteredQuotes.sort((q1, q2) => {
    if (q2.receivedAmount === q1.receivedAmount) {
      return sortWiseFollowedByOthers(q1, q2);
    }
    return q2.receivedAmount - q1.receivedAmount;
  });
}

export default sortQuotesByReceivedAmount;
